module.exports = __webpack_public_path__ + "img/email-template-blue-wave.043b7ae5.png";